import { render, staticRenderFns } from "./slotConfirmation.vue?vue&type=template&id=6e2c247e"
import script from "./slotConfirmation.vue?vue&type=script&lang=js"
export * from "./slotConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports